import {InviteI18n} from '@/locales/base.message.locales';

export const invites: InviteI18n = {
  title: 'Pendent Invitations',
  labels: {
    accepted: 'Accepted',
    pendent: 'Pendent',
    refused: 'Refused',
  },
  messages: {
    accepted: {
      failed: 'Fail to accept this invitation',
      success: 'Invitation has accepted',
    },
    refused: {
      failed: 'fail to refuse this invitation',
      success: 'Invitation has refused',
    },
    canceled: {
      failed: 'fail to cancel this invitation',
      success: 'Invitation has canceled',
    },
    send: {
      failed: 'Fail to send your invitation',
      success: 'Invitation has send',
    },
  },
  buttons: {
    accept: 'Accept',
    refuse: 'Refuse',
    cancel_invite: 'Cancel invite',
    accept_invite: 'Accept invite'
  }
};
